import { css } from '@styled-system/css';
import styled from 'styled-components';
import { variant } from 'styled-system';
export var TabLink = function (_a) {
    var children = _a.children, scrollRef = _a.scrollRef, onClick = _a.onClick, render = _a.render, href = _a.href, dataTestid = _a.dataTestid, _b = _a.className, className = _b === void 0 ? '' : _b;
    return render({ children: children, scrollRef: scrollRef, onClick: onClick, href: href, dataTestid: dataTestid, className: className });
};
var Tab = styled(TabLink)(css({
    cursor: 'pointer',
    fontSize: ['1.2rem', '1.4rem'],
    lineHeight: ['1.2rem', '2rem'],
    minWidth: '11rem',
    padding: '2.4rem 0.5rem',
    textAlign: 'center',
    width: '100%',
}), function (_a) {
    var theme = _a.theme;
    return variant({ variants: theme.component.tab });
}, function (_a) {
    var theme = _a.theme, selected = _a.selected;
    return selected
        ? css({
            fontFamily: theme.fonts.bold,
            color: theme.colors.black,
        })
        : css({
            color: theme.colors.grayMedium,
            fontFamily: theme.fonts.medium,
        });
}, function (_a) {
    var _b = _a.theme, colors = _b.colors, component = _b.component, isPrimary = _a.isPrimary, selected = _a.selected, variant = _a.variant;
    if (isPrimary) {
        return selected
            ? css({
                borderBottom: "0.1rem solid ".concat(colors[component.tab[variant].backgroundColor]),
            })
            : css({
                borderBottom: "0.1rem solid ".concat(colors.grayLightest),
            });
    }
}, function (_a) {
    var colors = _a.theme.colors, isPrimary = _a.isPrimary, selected = _a.selected;
    return (!isPrimary || !selected) && css({ backgroundColor: colors.white });
});
export default Tab;
